import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Mission from './components/Mission';
import Director from './components/Director';
import Service from './components/Service';
import WhatPeopleSay from './components/WhatPeopleSay';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import Gallery from './components/Gallery'; // Import the Gallery component
import Offer from './components/Offer'; // Import the JobOffer component
import Statistique from './components/Statistique';

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Mission />
      <Director />
      <Service />
      <WhatPeopleSay />
      <ContactUs />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/job-offer" element={<Offer />} />
        <Route path="/statics-lng" element={<Statistique />} />
      </Routes>
      {/* <Footer /> */}
    </Router>
  );
}

export default App;